import { IImage } from '../interface/IListing';

export function useImages(imageList: IImage[]) {
  const getIndexOrZero = (type: string) => {
    const idx = imageList.findIndex((image) => image.type === type);
    return idx === -1 ? 0 : idx;
  };

  const images = {
    featuredImage: imageList.find((image) => image.type === 'Featured'),
    featuredIndex: getIndexOrZero('Featured'),
    specImage: imageList.find((image) => image.type === 'Spec'),
    specIndex: getIndexOrZero('Spec'),
    galleryThumbnails: sortGallery(imageList, 'thumbnail'),
    gallery: sortGallery(imageList, 'extraLarge'),
  };

  return {
    images,
  };
}

function sortGallery(
  imageList: IImage[],
  sizeType: 'thumbnail' | 'extraLarge' | 'large' | 'original'
) {
  // Separate the featured image and other images
  const featuredImage = imageList.find((image) => image.type === 'Featured');
  const specImage = imageList.find((image) => image.type === 'Spec');
  const otherImages = imageList.filter(
    (image) => image.type !== 'Spec' && image.type !== 'Featured'
  );

  // Map to the required size, defaulting to 'original' if not found
  const mappedImages = otherImages.map((image) => {
    const imageSize =
      image.sizes[sizeType] || image.sizes.large || image.sizes.original;
    return imageSize;
  });

  // Place the featured image at the start if it exists
  if (featuredImage) {
    const featuredSize =
      featuredImage.sizes[sizeType] ||
      featuredImage.sizes.large ||
      featuredImage.sizes.original;
    mappedImages.unshift(featuredSize);
  }

  // Place the spec image at the end if it exists
  if (specImage) {
    const specSize =
      specImage.sizes[sizeType] ||
      specImage.sizes.large ||
      specImage.sizes.original;
    mappedImages.push(specSize);
  }

  return mappedImages;
}
